import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const steps = ['Open the modules.', 'Review the exercises.', 'Try the ready-to-use sessions.', 'Explore the programming and professional resources.'];
export function Guarantee() {
  return <section className="bg-ivory-deep px-4 sm:px-6 py-9 sm:py-12" data-id="element-72" data-mp="221byja0bzw2y">
      <div className="max-w-2xl mx-auto bg-white border-2 border-gold/50 rounded-xl p-5 sm:p-8 text-center shadow-sm" data-id="element-73" data-mp="1x5mvuxt0lz2f">
        <div className="w-11 h-11 mx-auto rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center mb-3" data-id="element-74" data-mp="19f0nt6j0gesf">
          <ShieldCheckIcon className="w-5 h-5 text-gold" data-id="element-75" data-mp="1j4k6oc6q48na" />
        </div>

        <h2 className="font-heading font-extrabold uppercase text-base sm:text-xl leading-tight tracking-tight text-petrol mb-3" data-id="element-76" data-mp="1j5vcehjqbqh1">
          7-Day Money-Back Guarantee
        </h2>

        <p className="text-[13px] sm:text-base font-semibold text-petrol/85 mb-3" data-id="element-77" data-mp="qmyd0bt1vsq3">
          Explore the complete system.
        </p>

        <ul className="max-w-xs sm:max-w-sm mx-auto mb-4" data-id="element-78" data-mp="lnc0k4l1qgic">
          {steps.map(step => <li key={step} className="text-[12px] sm:text-sm text-petrol/70 leading-snug border-b border-petrol/10 py-1.5 last:border-b-0" data-id="element-79" data-mp="oxf7m220gbov">
              {step}
            </li>)}
        </ul>

        <p className="text-[12px] sm:text-sm text-petrol/70 leading-relaxed max-w-lg mx-auto mb-3" data-id="element-80" data-mp="12r6airl8kxbm">
          You have 7 full days to decide whether Fitness Senior Ready™ belongs
          in your coaching workflow. If it isn't right for you, request a refund
          within the guarantee period.
        </p>

        <p className="font-heading font-extrabold uppercase text-[11px] sm:text-sm tracking-[0.12em] text-petrol pt-3 border-t border-gold/30" data-id="element-81" data-mp="f0ajhwolu65f">
          Your purchase is protected.
        </p>
      </div>
    </section>;
}